(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('roleController', roleController)
        .controller('newRoleController', newRoleController)
        .controller('editRoleController', editRoleController)
        .controller('deleteRoleController', deleteRoleController);

    roleController.$inject = ['roles', 'linkService'];
    newRoleController.$inject = ['$translate', 'roleService','clients','menuService','$scope','$timeout'];
    editRoleController.$inject = ['$translate', 'role', 'roleService', 'linkService',
        '$stateParams', 'clients', 'menuService','$scope','$timeout'];
    deleteRoleController.$inject = ['roleId', 'role', 'roleService', '$uibModalInstance'];

    function roleController(roles, linkService){
        var vm = this;
        vm.pages = [];
        vm.roles = (roles.data._embedded) ? roles.data._embedded.roles : [];;
        vm.linkService = linkService;
        vm.pages = roles.data.page;
    }

    function newRoleController($translate, roleService, clients, menuService,$scope,$timeout){
        var vm = this;
        vm.menus = [];
        vm.clients = clients != undefined && clients.data?clients.data:[];
        vm.menuAccess = [];
        vm.treeConfig = getTreeConfig();
        vm.requiredCheck = false;

        vm.getMenus = function(client){
            vm.requiredCheck = false;
            getMenus(client, menuService, vm, $translate, false,$timeout);
        }

        vm.saveRole = function(isValid, role){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            if(isValid){
                if(selected_nodes.length == 0){
                    vm.requiredCheck = false;
                }else{
                    var saveRole = {
                        'menus': selected_nodes,
                        'role': {
                            'name': role.name,
                            'clientId': role.client
                        }
                    }
                    roleService.saveRole(saveRole);
                }
            }else{
                /*if(selected_nodes.length == 0){
                    vm.requiredCheck = true;
                }else{
                    vm.requiredCheck = false;
                }*/
                setChangeRequiredCheck(vm, selected_nodes.length);
            }
        }

        $scope.selectNode = function(node, selected, event){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            /*if(selected_nodes.length == 0){
                vm.requiredCheck = false;
            }else{
                vm.requiredCheck = true;
            }*/
            setChangeRequiredCheck(vm, selected_nodes.length);
        }

        $scope.deselectNode = function(node, selected, event){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            /*if(selected_nodes.length == 0){
                vm.requiredCheck = false;
            }else{
                vm.requiredCheck = true;
            }*/
            setChangeRequiredCheck(vm, selected_nodes.length);
        }
    }

    function editRoleController($translate, role, roleService, linkService, $stateParams, clients, menuService, $scope,$timeout){
        var vm = this;
        vm.roleId = $stateParams.id;
        //vm.menus = menus.data;
        vm.menus = [];
        vm.role = role.data;
        vm.role.client = vm.role.clientId;
        vm.ids = idsMenu(role.data._embedded.roleAccesses);
        vm.clients = clients != undefined && clients.data?clients.data:[];
        //vm.menuAccess = refactorJsonEdit(vm.menus, vm.ids, $translate);
        vm.menuAccess = [];
        vm.treeConfig = getTreeConfig();
        vm.requiredCheck = true;
        vm.cont = 0;
        vm.old = angular.copy(vm.role);
        vm.oldMenuAccess = [];
        //vm.oldIds = angular.copy(vm.ids);
        vm.buttonSave = true;
        vm.contMenu = 0;

        vm.getMenus = function(client){
            vm.requiredCheck = vm.cont>0?false:true;
            getMenus(client, menuService, vm, $translate,true,$timeout);
            vm.cont++;
            if(vm.contMenu>0){
                $timeout(function(){
                    vm.change();
                },100);
            }
        }
        vm.getMenus(vm.role.clientId);

        vm.saveRole = function(isValid, role){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            if(isValid){
                if(selected_nodes.length == 0){
                    vm.requiredCheck = false;
                }else{
                    var updateRole = {
                        'menus': selected_nodes,
                        'role': {
                            'name': role.name,
                            'clientId': role.client
                        }
                    }
                    roleService.updateRole(updateRole, vm.roleId);
                }
            }else{
                setChangeRequiredCheck(vm, selected_nodes.length);
            }
        }

        function idsMenu(roleAccesses){
            var menuIds = [];
            angular.forEach(roleAccesses, function(roleAccess){
                var ids = linkService.getLinkIds(roleAccess._links.self.href);
                menuIds.push(ids[0]);
            });
            return menuIds;
        }

        $scope.selectNode = function(node, selected, event){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            setChangeRequiredCheck(vm, selected_nodes.length);
            vm.change();
        }

        $scope.deselectNode = function(node, selected, event){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            setChangeRequiredCheck(vm, selected_nodes.length);
            vm.change();
        }

        vm.change = function(){
            var selected_nodes = angular.element('#menuAccess').jstree(true).get_selected();
            /*var flagMenuAccess = [];
            if(vm.menuAccess.length==vm.oldIds.length){
                flagMenuAccess = vm.oldIds;
            }else{
                flagMenuAccess = vm.oldMenuAccess;
            }*/
            setChangeRequiredCheck(vm, selected_nodes.length);

            if(vm.role.name.toUpperCase() == vm.old.name.toUpperCase() &&
                vm.role.client != undefined && vm.role.client == vm.old.client &&
                vm.oldMenuAccess.length==selected_nodes.length){
                for(var i=0; i<selected_nodes.length; i++){
                    var flag = false;
                    for(var j=0; j<vm.oldMenuAccess.length; j++){
                        if(selected_nodes[i]==vm.oldMenuAccess[j]){
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        vm.buttonSave = false;
                        break;
                    }
                }
                if(flag){
                    vm.buttonSave=true;
                }
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteRoleController(roleId, role, roleService, $uibModalInstance){
        var vm = this;
        vm.name = role.data.name;

        vm.deleteRole = function(){
            roleService.deleteRole(roleId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function refactorJson(menus, $translate){
        var data = [];
        angular.forEach(menus, function(menu){
            data.push({"id": menu.id, "parent": "#", "text": $translate.instant(menu.initials)});
            if(menu.menus.length){
                angular.forEach(menu.menus, function(subMenus){
                    data.push({"id": subMenus.id, "parent": menu.id, "text": $translate.instant(subMenus.initials)});
                    if(subMenus.menus){
                        angular.forEach(subMenus.menus, function(option){
                            data.push({"id": option.id, "parent": subMenus.id, "text": $translate.instant(option.initials)});
                        });
                    }
                })
            }
        });
        return data;
    }

    function refactorJsonEdit(menus, ids, $translate){
        var data = [];

        angular.forEach(menus, function(menu){
            if(menu.menus.length>0){
                data.push({"id": menu.id, "parent": "#", "text": $translate.instant(menu.initials),  "state" : { "selected" : false }});
                angular.forEach(menu.menus, function(subMenus){
                    if(subMenus.menus.length >0){
                        data.push({"id": subMenus.id, "parent": menu.id, "text": $translate.instant(subMenus.initials),  "state" : { "selected" : false }});
                        angular.forEach(subMenus.menus, function(option){
                            if(ids.indexOf(option.id) == -1){
                                data.push({"id": option.id, "parent": subMenus.id, "text": $translate.instant(option.initials),  "state" : { "selected" : false }});
                            }else{
                                data.push({"id": option.id, "parent": subMenus.id, "text": $translate.instant(option.initials), "state" : {"selected" : true }});
                            }
                        });
                    }else{
                        if(ids.indexOf(subMenus.id) == -1){
                            data.push({"id": subMenus.id, "parent": menu.id, "text": $translate.instant(subMenus.initials),  "state" : { "selected" : false }});
                        }else{
                            data.push({"id": subMenus.id, "parent": menu.id, "text": $translate.instant(subMenus.initials), "state" : {"selected" : true }});
                        }
                    }
                })
            }else{
                if(ids.indexOf(menu.id) == -1){
                    data.push({"id": menu.id, "parent": "#", "text": $translate.instant(menu.initials),  "state" : { "selected" : false }});
                }else{
                    data.push({"id": menu.id, "parent": "#", "text": $translate.instant(menu.initials),  "state" : { "selected" : true }});
                }
            }
        });
        return data;
    }

    function getTreeConfig(){
        return {
            core : {
                multiple : true,
                animation: true,
                error : function(error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback : true,
                worker : true,
                themes: {
                    "icons": false
                }
            },
            version : 1,
            plugins : ['types','checkbox']
        }
    }

    function getMenus(client, menuService, vm, $translate, edit,$timeout){
        if(client != undefined){
            menuService.getMenusClient(client)
                .then(function(response){
                    vm.menus = response.data;
                    if(edit){
                        vm.menuAccess = refactorJsonEdit(vm.menus, vm.ids, $translate);
                        $timeout(function(){
                            if(vm.contMenu == 0){
                                vm.oldMenuAccess = angular.element('#menuAccess').jstree(true).get_selected();
                                vm.contMenu++;
                            }
                        },80);
                    }else{
                        vm.menuAccess = refactorJson(vm.menus, $translate);
                    }
                    vm.treeConfig.version++;
                });
        }else{
            vm.menus = [];
            vm.menuAccess = [];
            vm.treeConfig.version++;
        }
    }

    function setChangeRequiredCheck(vm, length){
        if(length == 0){
            vm.requiredCheck = false;
        }else{
            vm.requiredCheck = true;
        }
    }
})();
